import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";

export const carouselSettings = {
  autoplay: true,
  autoplaySpeed: 5000,
  cssEase: "linear",
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 2,
  slidesToScroll: 1,
  pauseOnHover: true,
  responsive: [
    // {
    //   breakpoint: 1024,
    //   settings: {
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     infinite: true,
    //     dots: true
    //   }
    // },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
    },
  ],
  nextArrow: (
    <ArrowForwardIosRoundedIcon sx={{ fontSize: 40 }} color="success" />
  ),
  prevArrow: <ArrowBackIosRoundedIcon sx={{ fontSize: 40 }} color="success" />,
};
